import React from "react";
import { Button } from "antd";
import AddProduct from "../../components/product/AddProduct";

const AddProductPage = () => {
	return (
		<>
			<AddProduct button={Button} />
		</>
	);
};

export default AddProductPage;
